import { Search, Grid, Heart, Clock, Folder } from 'lucide-react';
import { UserButton, useUser } from '@clerk/clerk-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useResponsive } from '@/hooks/useBreakpoint';

export const TopBar = () => {
  const { user } = useUser();
  const { isMobile } = useResponsive();

  return (
    <header className="flex flex-col border-b bg-background">
      <div className="flex h-16 md:h-20 items-center justify-between px-4 md:px-8">
        <div className="relative flex-1 max-w-xl">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="search"
            placeholder={isMobile ? 'Search...' : 'Search your library of bookmarks...'}
            className="w-full rounded-2xl bg-secondary/50 pl-10 border-transparent focus-visible:ring-primary h-10"
          />
        </div>

        <div className="flex items-center gap-3 md:gap-6 ml-4">
          {!isMobile && (
            <>
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary/80 text-foreground cursor-pointer hover:bg-secondary transition-colors">
                <Grid className="h-4 w-4" />
              </div>
              <div className="h-8 w-[1px] bg-border" />
            </>
          )}
          <div className="flex items-center gap-3">
            {!isMobile && (
              <div className="flex flex-col items-end">
                <span className="text-sm font-semibold">{user?.fullName ?? 'User'}</span>
                <span className="text-xs text-muted-foreground uppercase tracking-wider">
                  Premium Member
                </span>
              </div>
            )}
            <UserButton
              afterSignOutUrl="/login"
              appearance={{
                elements: {
                  userButtonAvatarBox: isMobile ? 'h-8 w-8' : 'h-10 w-10',
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* Secondary Navigation / Filter Pills */}
      <div className="flex items-center gap-2 overflow-x-auto px-4 pb-4 md:px-8 no-scrollbar">
        <Button
          variant="secondary"
          size="sm"
          className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-4"
        >
          All
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full text-muted-foreground hover:bg-secondary gap-2 px-4"
        >
          <Heart className="h-3.5 w-3.5" />
          Favorites
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full text-muted-foreground hover:bg-secondary gap-2 px-4"
        >
          <Clock className="h-3.5 w-3.5" />
          Recent
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full text-muted-foreground hover:bg-secondary gap-2 px-4"
        >
          <Folder className="h-3.5 w-3.5" />
          Design
        </Button>
      </div>
    </header>
  );
};
